import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import { getDataByKey, getTitleByKey, findIndexByKey, isNotNil, renderData, isNotNilDataByKey } from '../../../../helpers'
import { useFetch } from '../../../../hooks'
import Tabs from '../../../../modules/Tabs'
import PageLoader from '../../../../components/PageLoader'
import Params from './tabs/Params';
import Sensors from './tabs/Sensors';
// import Notes from './tabs/Notes';
import { StyledZoneCard } from './styled'
import { Store } from '../../../../context/store';
import useBuffer from '../../../../hooks/useBuffer';
import FooterBar from '../../../../modules/FooterBar';
import ButtonDouble from '../../../../components/inputs/ButtonDouble';
import { length, inc, compose, pathOr, toLower, join, split, head } from 'ramda';
import Icon from '../../../../components/Icon';
import FormGenerateReport from '../../../../modules/forms/FormGenerateReport';
import Modal from '../../../../components/Modal';
import Drawer from '../../../../components/Drawer';
import FormRemove from '../../components/FormRemove';
import { StyledDrawerItemWrapper, StyledDrawerItemIcon, StyledDrawerItemText } from '../../../../components/Drawer/styled';
import FormEditZone from '../../components/FormEditZone';

const ZoneCard = () => {
    const { state: { zonesList } } = Store();
    const history = useHistory();
    const { state, state: { rowid = null } = {} } = useLocation();
    const [zone, setZone] = useState({ data: [] });

    const { error: errorZone, fetching: fetchingZone, doFetch: doFetchZone } = useFetch({
        url: `/zonecard?row_id=eq.${rowid}`,
        method: 'GET',
        lazy: true
    });

    const doFetch = ({ item, loader, returnLastUpdate }) => new Promise(async (resolve, reject) => {
        const resZoneCard = await doFetchZone({
            url: `/zonecard?row_id=eq.${item.row_id}`,
            loader,
            returnLastUpdate
        });
        resolve(resZoneCard);
    });

    const { index, setIndex, refetchBuffer, onClickPrevItem, onClickNextItem } = useBuffer({
        list: zonesList,
        doFetch: doFetch,
        setItem: item => setZone(item),
        id: "row_id",
        returnLastUpdate: true
    });

    const reFetchZoneCard = (param = {}) => {
        const { loader = false, refetchCurr = true } = param;
        return refetchBuffer({ loader, refetchCurr });
    }

    useEffect(() => {
        if (zone.data.length > 0) {
            const parseNameToURL = compose(
                toLower,
                join('-'),
                split(' '),
                pathOr("", ['row_no']),
                head,
                pathOr([], ['data'])
            );
            const getRowID = compose(
                pathOr(null, ['row_id']),
                head,
                pathOr([], ['data'])
            );
            history.replace({
                pathname: `/manage/zones/${parseNameToURL(zone)}`,
                state: {
                    ...state,
                    rowid: getRowID(zone)
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zone])


    useEffect(() => {
        if (isNotNil(rowid)) {
            if (index === null) {
                const currIndex = findIndexByKey('row_id', rowid, zonesList)
                setIndex(currIndex)
            }
        } else {
            history.push('/')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowid]);


    const renderDataState = renderData({ data: zone, error: errorZone, fetching: fetchingZone });

    return (
        <StyledZoneCard>
            {
                renderDataState({
                    fetching: () => (<PageLoader />),
                    error: error => (<div>{error.toString()}</div>),
                    data: data => (
                        <Tabs
                            headBar={{
                                title: getDataByKey(data, 'title', ''),
                                children: (
                                    <Drawer
                                    drawerItems={[
                                        {
                                            customContent: ({ handleToggleIsOpenDrawer }) => (
                                                <Modal
                                                    renderOpenButton={
                                                        ({ handleToggleIsOpenModal }) => (
                                                            <StyledDrawerItemWrapper onClick={handleToggleIsOpenModal}>
                                                                <StyledDrawerItemIcon name='edit' />
                                                                <StyledDrawerItemText>
                                                                    {pathOr("", ["edit", "form-button"], getDataByKey(data, 'menu-modal', {}))}
                                                                </StyledDrawerItemText>
                                                            </StyledDrawerItemWrapper>
                                                        )
                                                    }
                                                >
                                                    {
                                                        ({ handleToggleIsOpenModal }) => (
                                                            <FormEditZone
                                                                zoneid={getDataByKey(data, 'row_id', null)}
                                                                zonename={getDataByKey(data, 'row_no', "")}
                                                                onClickCancel={handleToggleIsOpenModal}
                                                                onClickClose={
                                                                    () => {
                                                                        handleToggleIsOpenModal();
                                                                        handleToggleIsOpenDrawer();
                                                                    }
                                                                }
                                                                refetchZoneCard={reFetchZoneCard}
                                                                translation={pathOr({}, ["edit", "modal"], getDataByKey(data, 'menu-modal', {}))}
                                                            />
                                                        )
                                                    }
                                                </Modal>
                                            )
                                        }, 
                                        {
                                            customContent: () => (
                                                <Modal
                                                    renderOpenButton={
                                                        ({ handleToggleIsOpenModal }) => (
                                                            <StyledDrawerItemWrapper onClick={handleToggleIsOpenModal}>
                                                                <StyledDrawerItemIcon name='remove' />
                                                                <StyledDrawerItemText>
                                                                    {pathOr("", ["delete-zone", "form-button"], getDataByKey(data, 'menu-modal', {}))}
                                                                </StyledDrawerItemText>
                                                            </StyledDrawerItemWrapper>
                                                        )
                                                    }
                                                >
                                                    {
                                                        ({ handleToggleIsOpenModal }) => (
                                                            <FormRemove
                                                                data={{
                                                                    zoneid: getDataByKey(data, 'row_id', null)
                                                                }}
                                                                url='/rpc/remove_zone'
                                                                urlUndo='/rpc/remove_zone_undo'
                                                                redirect='/manage/zones'
                                                                onClickCancel={handleToggleIsOpenModal}
                                                                translation={pathOr({}, ["delete-zone", "modal"], getDataByKey(data, 'menu-modal', {}))}
                                                            />
                                                        )
                                                    }
                                                </Modal>
                                            )
                                        }, 
                                        {
                                            customContent: () => (
                                                <Modal
                                                    renderOpenButton={
                                                        ({ handleToggleIsOpenModal }) => (
                                                            <StyledDrawerItemWrapper onClick={handleToggleIsOpenModal}>
                                                                <StyledDrawerItemIcon name='report' />
                                                                <StyledDrawerItemText>
                                                                    {pathOr("", ["report", "form-button"], getDataByKey(data, 'menu-modal', {}))}
                                                                </StyledDrawerItemText>
                                                            </StyledDrawerItemWrapper>
                                                        )
                                                    }
                                                >
                                                    {
                                                        ({ handleToggleIsOpenModal }) => (
                                                            <FormGenerateReport
                                                                type="zone"
                                                                dataKey="row_id"
                                                                icon="zones"
                                                                id={getDataByKey(data, 'row_id', null)}
                                                                report={pathOr(null, ["report"], getDataByKey(data, 'menu-modal', {}))}
                                                                endpointExecute={'reportzoneexecute'}
                                                                onClickCancel={handleToggleIsOpenModal}
                                                            />
                                                        )
                                                    }
                                                </Modal>
                                            )
                                        }
                                    ]}
                                />
                                )
                            }}
                            tabs={[
                                {
                                    id: 'parameters',
                                    name: getTitleByKey(data, 'params'),
                                    component: <Params
                                        rowid={getDataByKey(data, 'row_id')}
                                        params={getDataByKey(data, 'params', [])}
                                    />,
                                    showTab: isNotNilDataByKey(data, 'params')
                                },
                                {
                                    id: 'sensors',
                                    name: getTitleByKey(data, 'sensors'),
                                    component: <Sensors
                                        rowid={getDataByKey(data, 'row_id')}
                                        sensors={getDataByKey(data, 'sensors', [])}
                                        refetchZone={reFetchZoneCard}
                                    />,
                                    showTab: isNotNilDataByKey(data, 'sensors')
                                },
                                // {
                                //     id: 'notes',
                                //     name: 'notatki',
                                //     component: <Notes />
                                // }
                            ]}
                        />
                    )
                })
            }
            <FooterBar noDivider>
                {
                    length(zonesList) !== 0 &&
                    <ButtonDouble style={{ marginLeft: 'auto' }} onClickLeft={onClickPrevItem} onClickRight={onClickNextItem} disabled={length(zonesList) === 1}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Icon name="zones" width="24" height="24" />
                            <div style={{ fontSize: '12px' }}>{`${index !== null && index > -1 ? inc(index) : '-'}/${length(zonesList)}`}</div>
                        </div>
                    </ButtonDouble>
                }
            </FooterBar>
        </StyledZoneCard>
    )
}

export default ZoneCard